@if (showExtend()) {
  <aside class="alert-holder" aria-label="Varning om tidsgräns">
    <mat-card role="alert" aria-live="assertive" aria-atomic="true">
      <mat-card-content>
      <span>
        <strong>{{ minutesLeft() }} {{ minutesLeft() === 1 ? 'minut' : 'minuter' }}</strong>
        återstår av tidsgränsen för att slutföra ansökan.
      </span>
        <button matButton="filled" (click)="extendTimer()">
          Förläng
        </button>
      </mat-card-content>
    </mat-card>
  </aside>
}

<section class="form-holder">
  <mat-card>
    <mat-card-content>
      <mat-stepper
        spbStepperScroll
        [class.small-screen]="orientationService.isSmallScreen()"
        #stepper
        [linear]="!savingsAccountService.testMode()"
        [orientation]="orientationService.isSmallScreen() ?'vertical' : 'horizontal'"
        class="stepper"
      >
        <mat-step
          [hasError]="!welcomeForm.valid"
          [completed]="welcomeForm.valid" aria-label="Steg 1: Välkommen">
          <ng-template matStepLabel>
    <span class="stepper-text"
          [class.underline]="welcomeForm.valid && stepper.selectedIndex !== 0">
      Välkommen
    </span>
          </ng-template>
          <section>
            <spb-welcome [stepper]="stepper"
                         [welcomeForm]="welcomeForm"/>
            <div class="navigation-buttons"
                 [class.small-screen]="orientationService.isSmallScreen()">
              <button
                [disabled]="!welcomeForm.valid"
                matButton="filled"
                matStepperNext>
                Nästa
              </button>
            </div>
          </section>
        </mat-step>

        <mat-step
          [hasError]="!applicantsForm.valid && applicantsForm.touched"
          [completed]="applicantsForm.valid"
          aria-label="Steg 2: Kontaktuppgifter">
          <ng-template matStepLabel>
  <span class="stepper-text"
        [class.underline]="applicantsForm.valid && stepper.selectedIndex !== 1">
    Kontaktuppgifter
  </span>
          </ng-template>

          <section>
            <spb-applicants [applicantsForm]="applicantsForm"/>

            <div class="navigation-buttons"
                 [class.small-screen]="orientationService.isSmallScreen()">
              <button
                matButton="outlined"
                matStepperPrevious>
                Föregående
              </button>
              <button
                [disabled]="!applicantsForm.valid"
                matButton="filled"
                matStepperNext>
                Nästa
              </button>
            </div>
          </section>
        </mat-step>

        <mat-step
          [hasError]="!kycForm.valid && kycForm.touched"
          [completed]="kycForm.valid" aria-label="Steg 3: Kundkännedom">
          <ng-template matStepLabel>
  <span class="stepper-text"
        [class.underline]="kycForm.valid && stepper.selectedIndex !== 2">
    Kundkännedom
  </span>
          </ng-template>

          <section>
            <spb-kyc [kycForm]="kycForm"/>
          </section>
        </mat-step>

        <mat-step aria-label="Steg 4: Godkänn">
          <ng-template matStepLabel>
            <span class="stepper-text">Godkänn med BankID</span>
          </ng-template>
          <section>
            <spb-summary
              [stepperTrigger]="kycForm.valid && stepper.selectedIndex !== 2"
              [savingsAccountForm]="savingsAccountForm"/>
          </section>
        </mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</section>
